import { UserInfoContext } from "Context/CommonContext";
import { useContext, useEffect, useState } from "react";
import "./index.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import VideoPlayer from "Pages/AssetView/VideoPlayer";
import { BASE_URL, GET_VIDEO_URL } from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { Spinner } from "reactstrap";
import ErrorView from "Pages/AssetView/ErrorView";

interface IAssetInfo {
  courseId?: number | string;
  assetId?: number | string;
  title?: string;
  type?: string;
  desc?: string;
}
const VideoView = ({ assetId, courseId }: IAssetInfo) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [videoUrl, setVideoUrl] = useState<string>("");
  console.log(userInfo, assetId, "scheduleAssetData", videoUrl);
  const { makeRequest: fetchFile, loading } = useGetApi(
    (data: any) => {
      if (data?.data?.hls && data?.data?.hls != null) {
        setVideoUrl(data?.data?.hls);
      } else {
        setVideoUrl(data?.data?.dash);
      }
    },
    (error: any) => {
      console.error(error);
    }
  );
  useEffect(() => {
    fetchFile(
      BASE_URL + GET_VIDEO_URL + `?assetId=${assetId}&courseId=${courseId}`
    );
  }, [assetId]);
  return (
    <div className="mb-3 assetVideoView">
      {loading ? (
        <Spinner />
      ) : videoUrl && videoUrl != "" && videoUrl != null ? (
        <VideoPlayer
          videoUrl={videoUrl}
          JWTToken={""}
          assetId={assetId}
          // videoUrl={
          //   "https://content-staging-aakash.s3.ap-south-1.amazonaws.com/Media/Video/422745/dash/sample-5.mpd"
          // }
        ></VideoPlayer>
      ) : (
        <ErrorView />
      )}
    </div>
  );
};

export default VideoView;
